/* 🤖 this file was generated by svg-to-ts */
export const matIconPhotoAlbum: {
  name: 'photo-album';
  data: string;
} = {
  name: 'photo-album',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V4h5v7l2.5-1.5L16 11V4h2v16zm-4.38-6.5L17 18H7l2.38-3.17L11 17l2.62-3.5z"/></svg>`
};
